// @generated by protoc-gen-es v2.10.1 with parameter "target=ts"
// @generated from file cortado/v1/questionnaires.proto (package cortado.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file cortado/v1/questionnaires.proto.
 */
export const file_cortado_v1_questionnaires: GenFile = /*@__PURE__*/
  fileDesc("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");

/**
 * Questionnaire is a self-contained list of questions, optionally with answers.
 * Booking snapshots copy prompt/type/options so later template edits do not
 * affect existing bookings.
 *
 * @generated from message cortado.v1.Questionnaire
 */
export type Questionnaire = Message<"cortado.v1.Questionnaire"> & {
  /**
   * @generated from field: repeated cortado.v1.QuestionnaireItem items = 1;
   */
  items: QuestionnaireItem[];
};

/**
 * Describes the message cortado.v1.Questionnaire.
 * Use `create(QuestionnaireSchema)` to create a new message.
 */
export const QuestionnaireSchema: GenMessage<Questionnaire> = /*@__PURE__*/
  messageDesc(file_cortado_v1_questionnaires, 0);

/**
 * @generated from message cortado.v1.QuestionnaireItem
 */
export type QuestionnaireItem = Message<"cortado.v1.QuestionnaireItem"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: int32 order = 2;
   */
  order: number;

  /**
   * @generated from field: string prompt = 20;
   */
  prompt: string;

  /**
   * @generated from field: optional string description = 21;
   */
  description?: string;

  /**
   * @generated from field: cortado.v1.QuestionTypeEnum type = 22;
   */
  type: QuestionTypeEnum;

  /**
   * @generated from field: bool required = 50;
   */
  required: boolean;

  /**
   * @generated from field: repeated cortado.v1.QuestionnaireOption options = 23;
   */
  options: QuestionnaireOption[];

  /**
   * @generated from field: optional cortado.v1.QuestionnaireAnswer answer = 24;
   */
  answer?: QuestionnaireAnswer;
};

/**
 * Describes the message cortado.v1.QuestionnaireItem.
 * Use `create(QuestionnaireItemSchema)` to create a new message.
 */
export const QuestionnaireItemSchema: GenMessage<QuestionnaireItem> = /*@__PURE__*/
  messageDesc(file_cortado_v1_questionnaires, 1);

/**
 * @generated from message cortado.v1.QuestionnaireOption
 */
export type QuestionnaireOption = Message<"cortado.v1.QuestionnaireOption"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string label = 20;
   */
  label: string;

  /**
   * @generated from field: int32 display_order = 21;
   */
  displayOrder: number;
};

/**
 * Describes the message cortado.v1.QuestionnaireOption.
 * Use `create(QuestionnaireOptionSchema)` to create a new message.
 */
export const QuestionnaireOptionSchema: GenMessage<QuestionnaireOption> = /*@__PURE__*/
  messageDesc(file_cortado_v1_questionnaires, 2);

/**
 * QuestionnaireAnswer is the typed response for one item. Labels on choice
 * answers are filled by the server from the snapshot options.
 *
 * @generated from message cortado.v1.QuestionnaireAnswer
 */
export type QuestionnaireAnswer = Message<"cortado.v1.QuestionnaireAnswer"> & {
  /**
   * @generated from oneof cortado.v1.QuestionnaireAnswer.value
   */
  value: {
    /**
     * @generated from field: string text = 1;
     */
    value: string;
    case: "text";
  } | {
    /**
     * @generated from field: bool boolean = 2;
     */
    value: boolean;
    case: "boolean";
  } | {
    /**
     * @generated from field: cortado.v1.QuestionnaireChoice choice = 3;
     */
    value: QuestionnaireChoice;
    case: "choice";
  } | {
    /**
     * @generated from field: cortado.v1.QuestionnaireMultiChoice multi_choice = 4;
     */
    value: QuestionnaireMultiChoice;
    case: "multiChoice";
  } | {
    /**
     * @generated from field: cortado.v1.QuestionnaireFiles files = 5;
     */
    value: QuestionnaireFiles;
    case: "files";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message cortado.v1.QuestionnaireAnswer.
 * Use `create(QuestionnaireAnswerSchema)` to create a new message.
 */
export const QuestionnaireAnswerSchema: GenMessage<QuestionnaireAnswer> = /*@__PURE__*/
  messageDesc(file_cortado_v1_questionnaires, 3);

/**
 * @generated from message cortado.v1.QuestionnaireChoice
 */
export type QuestionnaireChoice = Message<"cortado.v1.QuestionnaireChoice"> & {
  /**
   * @generated from field: string option_id = 1;
   */
  optionId: string;

  /**
   * @generated from field: string option_label = 2;
   */
  optionLabel: string;
};

/**
 * Describes the message cortado.v1.QuestionnaireChoice.
 * Use `create(QuestionnaireChoiceSchema)` to create a new message.
 */
export const QuestionnaireChoiceSchema: GenMessage<QuestionnaireChoice> = /*@__PURE__*/
  messageDesc(file_cortado_v1_questionnaires, 4);

/**
 * @generated from message cortado.v1.QuestionnaireMultiChoice
 */
export type QuestionnaireMultiChoice = Message<"cortado.v1.QuestionnaireMultiChoice"> & {
  /**
   * @generated from field: repeated cortado.v1.QuestionnaireChoice choices = 1;
   */
  choices: QuestionnaireChoice[];
};

/**
 * Describes the message cortado.v1.QuestionnaireMultiChoice.
 * Use `create(QuestionnaireMultiChoiceSchema)` to create a new message.
 */
export const QuestionnaireMultiChoiceSchema: GenMessage<QuestionnaireMultiChoice> = /*@__PURE__*/
  messageDesc(file_cortado_v1_questionnaires, 5);

/**
 * QuestionnaireFile references a booking attachment uploaded as a file-upload
 * answer. Only attachment_id is read on write; the server fills the rest from
 * the attachment row.
 *
 * @generated from message cortado.v1.QuestionnaireFile
 */
export type QuestionnaireFile = Message<"cortado.v1.QuestionnaireFile"> & {
  /**
   * @generated from field: string attachment_id = 1;
   */
  attachmentId: string;

  /**
   * @generated from field: string filename = 2;
   */
  filename: string;

  /**
   * @generated from field: string content_type = 3;
   */
  contentType: string;

  /**
   * @generated from field: int64 size_bytes = 4;
   */
  sizeBytes: bigint;
};

/**
 * Describes the message cortado.v1.QuestionnaireFile.
 * Use `create(QuestionnaireFileSchema)` to create a new message.
 */
export const QuestionnaireFileSchema: GenMessage<QuestionnaireFile> = /*@__PURE__*/
  messageDesc(file_cortado_v1_questionnaires, 6);

/**
 * @generated from message cortado.v1.QuestionnaireFiles
 */
export type QuestionnaireFiles = Message<"cortado.v1.QuestionnaireFiles"> & {
  /**
   * @generated from field: repeated cortado.v1.QuestionnaireFile files = 1;
   */
  files: QuestionnaireFile[];
};

/**
 * Describes the message cortado.v1.QuestionnaireFiles.
 * Use `create(QuestionnaireFilesSchema)` to create a new message.
 */
export const QuestionnaireFilesSchema: GenMessage<QuestionnaireFiles> = /*@__PURE__*/
  messageDesc(file_cortado_v1_questionnaires, 7);

/**
 * QuestionnaireAnswerInput is a customer/staff write of one item's answer.
 *
 * @generated from message cortado.v1.QuestionnaireAnswerInput
 */
export type QuestionnaireAnswerInput = Message<"cortado.v1.QuestionnaireAnswerInput"> & {
  /**
   * @generated from field: string item_id = 1;
   */
  itemId: string;

  /**
   * @generated from field: cortado.v1.QuestionnaireAnswer answer = 2;
   */
  answer?: QuestionnaireAnswer;
};

/**
 * Describes the message cortado.v1.QuestionnaireAnswerInput.
 * Use `create(QuestionnaireAnswerInputSchema)` to create a new message.
 */
export const QuestionnaireAnswerInputSchema: GenMessage<QuestionnaireAnswerInput> = /*@__PURE__*/
  messageDesc(file_cortado_v1_questionnaires, 8);

/**
 * QuestionTypeEnum is the input widget for a questionnaire item.
 *
 * @generated from enum cortado.v1.QuestionTypeEnum
 */
export enum QuestionTypeEnum {
  /**
   * @generated from enum value: QUESTION_TYPE_ENUM_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: QUESTION_TYPE_ENUM_FREE_FORM = 1;
   */
  FREE_FORM = 1,

  /**
   * @generated from enum value: QUESTION_TYPE_ENUM_PARAGRAPH = 2;
   */
  PARAGRAPH = 2,

  /**
   * @generated from enum value: QUESTION_TYPE_ENUM_MULTIPLE_CHOICE = 3;
   */
  MULTIPLE_CHOICE = 3,

  /**
   * @generated from enum value: QUESTION_TYPE_ENUM_MULTI_SELECT = 4;
   */
  MULTI_SELECT = 4,

  /**
   * @generated from enum value: QUESTION_TYPE_ENUM_PHONE = 5;
   */
  PHONE = 5,

  /**
   * ADDRESS is a single line of text. Clients should collect it with Google
   * Places autocomplete and persist the formatted address string.
   *
   * @generated from enum value: QUESTION_TYPE_ENUM_ADDRESS = 6;
   */
  ADDRESS = 6,

  /**
   * @generated from enum value: QUESTION_TYPE_ENUM_EMAIL = 7;
   */
  EMAIL = 7,

  /**
   * @generated from enum value: QUESTION_TYPE_ENUM_BOOLEAN = 8;
   */
  BOOLEAN = 8,

  /**
   * FILE_UPLOAD collects one file. Clients upload it with
   * UploadPublicBookingQuestionnaireFile, which stores it as an attachment on
   * the booking, then submit the returned attachment ID as the answer.
   *
   * @generated from enum value: QUESTION_TYPE_ENUM_FILE_UPLOAD = 9;
   */
  FILE_UPLOAD = 9,

  /**
   * FILE_UPLOAD_MULTIPLE is FILE_UPLOAD that accepts up to ten files.
   *
   * @generated from enum value: QUESTION_TYPE_ENUM_FILE_UPLOAD_MULTIPLE = 10;
   */
  FILE_UPLOAD_MULTIPLE = 10,
}

/**
 * Describes the enum cortado.v1.QuestionTypeEnum.
 */
export const QuestionTypeEnumSchema: GenEnum<QuestionTypeEnum> = /*@__PURE__*/
  enumDesc(file_cortado_v1_questionnaires, 0);

